"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initAnalyticsConfig = exports.getAnalyticsConfig = void 0;
/**
 * Конфиг со всеми настройками для событий
 */
var analyticsConfig;
function getAnalyticsConfig() {
    if (analyticsConfig) {
        return analyticsConfig;
    }
    throw new Error('Необходимо проинициализировать конфиг перед тем как пробрасывать события в метрики');
}
exports.getAnalyticsConfig = getAnalyticsConfig;
/**
 * @description Инициализация конфига
 * @param config Конфиг со всеми параметрами и мапингами для событий
 */
function initAnalyticsConfig(config) {
    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for (var event_1 in config) {
        var dimensionsMapping = config[event_1].dimensions;
        if (dimensionsMapping) {
            var dimensionNumbers = Object.values(dimensionsMapping);
            var countDimensions = function (currentDimensionNumbers) {
                return currentDimensionNumbers.reduce(function (countObject, dimension) {
                    var _a;
                    return (__assign(__assign({}, countObject), (_a = {}, _a[dimension] = (countObject[dimension] || 0) + 1, _a)));
                }, {});
            };
            var findDuplicates = function (currentCountDimensions) {
                return Object.keys(currentCountDimensions).filter(function (dimension) { return currentCountDimensions[dimension] > 1; });
            };
            var duplicateDimensions = findDuplicates(countDimensions(dimensionNumbers));
            if (duplicateDimensions.length) {
                throw new Error("\u041D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u043F\u0440\u043E\u0438\u043D\u0438\u0446\u0438\u0430\u043B\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u043D\u0444\u0438\u0433.\n" + event_1 + ": \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435 dimensions \u0432\u0441\u0442\u0440\u0435\u0447\u0430\u044E\u0442\u0441\u044F \u0431\u043E\u043B\u0435\u0435 \u043E\u0434\u043D\u043E\u0433\u043E \u0440\u0430\u0437\u0430: " + duplicateDimensions.join(', '));
            }
        }
    }
    analyticsConfig = config;
}
exports.initAnalyticsConfig = initAnalyticsConfig;

//# sourceMappingURL=config.js.map
